<template>
  <div v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <div>
      <!--<i class="el-icon-arrow-left"></i>-->
      <!--<span class="title">My To Do List</span>-->
    </div>

    <div id="breadcrumb">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ path:'/home' }"><i class="fa fa-home"></i> Home</router-link>
        </li>
        <li>
          <small>Access Control</small>
        </li>

        <li class="active">
          <small>Role Mgmt.</small>
        </li>
      </ol>
    </div>
    <confirmation-box ref="deleteDialog" @handleConfirm="confirmToremove"></confirmation-box>
    <add-role ref="addRole" @saveSuccess="saveRoleSuccess"></add-role>
    <edit-role ref="editRole" @saveSuccess="saveRoleSuccess" :roleInfo="roleInfo"></edit-role>
    <upload-file ref="uploadFileRef" @achieveState="achieveState" :roleInfo="roleInfo"></upload-file>
    <config-role-function ref="configRoleFunction" type="configRoleFunction"  @saveSuccess="saveRoleSuccess" ></config-role-function>
    <config-ticket-type ref="configTicketType" @saveSuccess="saveRoleSuccess"></config-ticket-type>
    <edit-report ref="editReport" @saveSuccess="saveRoleSuccess" :roleInfo="roleInfo"></edit-report>

    <div class="tab">
      <el-tabs class="el-tabs" type="border-card">
        <el-tab-pane label="Detail">
          <d1-vue-component ref="basicComponent" :options="generateOption" :dataFacetKey="dataFacetKey" :d1CoreBaseUrl="baseAcsUrl" :d1ClientBaseUrl="baseUrl"
                            @onTableOperationButtonClick="handleTableButtonClick"
                            @onToolbarButtonClick="handleToolbarButtonClick"
          ></d1-vue-component>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>

</template>

<script>

  import d1VueComponent from '@/components/d1/acs-d1-vue-component'
  import confirmationBox from '@/components/dialog/confirmation_box.vue'
  import addRole from '@/view/acs/role/dialog/add_role.vue'
  import editRole from '@/view/acs/role/dialog/edit_role.vue'
  import configRoleFunction from '@/view/acs/role/dialog/config_role_function.vue'
  import configTicketType from '@/view/acs/role/dialog/config_ticket_type_by_role.vue'
  import uploadFile from "@/components/importComponent/upload_user_guide.vue";
  import editReport from '@/view/acs/role/dialog/edit_report.vue'
  export default {
    props: {

    },
    components: {
      d1VueComponent,
      confirmationBox,
      addRole,
      editRole,
      configRoleFunction,
      configTicketType,
      uploadFile,
      editReport
    },
    data(){
      return{
        generateOption: {
          queryUrl: 'mdm-common/acs/role/get-roles?sort=gmt_modified,DESC&app_key='+ this.appKey ,
          importUrl: '',
          exportUrl: 'mdm-common/acs/role/export-roles?sort=gmt_modified,DESC',
          deleteUrl: '',
          modifyUrl: '',
          pageSize: 10,
          tableData: [{}],
          pageSettingData: {
            form: [{}],
            table: [{}]
          },
          showTableOperationButton: true,
          tableOperationButtonList: [
            {
              label: 'Upload', //按钮显示的名称
              type: '',  //按钮的类型,默认空,支持  primary，success，info，warning，danger
              name: 'upload', // 按钮点击时间触发的函数名称
              width: 80
            },
            {
              label: 'Edit', //按钮显示的名称
              type: '',  //按钮的类型,默认空,支持  primary，success，info，warning，danger
              name: 'edit', // 按钮点击时间触发的函数名称
              width: 80
            },
            {
              label: 'Config Function Permission', //按钮显示的名称
              type: '',  //按钮的类型,默认空,支持  primary，success，info，warning，danger
              name: 'function', // 按钮点击时间触发的函数名称
              width: 200
            },
            {
              label: 'Edit Report', //按钮显示的名称
              type: '',  //按钮的类型,默认空,支持  primary，success，info，warning，danger
              name: 'report', // 按钮点击时间触发的函数名称
              width: 120
            }

            // ,{
            //   label: 'Config Ticket Type By Role', //按钮显示的名称
            //   type: '',  //按钮的类型,默认空,支持  primary，success，info，warning，danger
            //   name: 'configTicketType', // 按钮点击时间触发的函数名称
            //   width: 200
            // }
          ],
          toolbarButtonList: [
            {
              label: 'Add ', //按钮显示的名称
              type: 'primary',  //按钮的类型,默认空,支持  primary，success，info，warning，danger
              name: 'add', // 用户点击时返回的组件
              elColWidth: 3, //按钮的占位
            },
            {
              label: 'Delete ', //按钮显示的名称
              type: 'danger',  //按钮的类型,默认空,支持  primary，success，info，warning，danger
              name: 'delete', // 用户点击时返回的组件
              elColWidth: 3, //按钮的占位
            }
          ],
          showToolbarButtonList: true,
          asyncExport:true,
          showSelectColumn: false,
          showTableSelection: true,
          openform:true,
          showForm: true,
          showPagination: true,
          tableDataFormatter: false

        },
        roleInfo:{},
        dataFacetKey: 'acs_role_list',
        dataLoading: false,
      }
    },
    computed: {

    },
    created(){
    },


    methods: {
      handleToolbarButtonClick(name) {
        if(name === 'add'){
         this.$refs.addRole.showAddRoleDialog();
        }else if(name === 'delete'){
          this.$refs.deleteDialog.showDialog();
        }else{
          //nothing to do
        }
      },
      handleTableButtonClick(row, name) {
        // this.handleApprove([row.store_seq], name);
        if(name === 'edit'){
          this.roleInfo = row;
          this.$refs.editRole.showEditRoleDialog();
        }else if(name === 'function'){
          this.$refs.configRoleFunction.showConfigRoleFunction(row);
        }else if(name=='upload'){
          console.log(row,'========upload')
          this.roleInfo = row;
          this.$refs.uploadFileRef.dialogVisible = true;
          this.$refs.uploadFileRef.fileList = [];
        }else if(name=='report'){
          console.log(row,'========report')
          this.roleInfo = row;
          this.$refs.editReport.editRoleDialogVisible = true;
        }else{
          this.$refs.configTicketType.showConfigTicketTypeByRole(row);
        }
      },
      saveRoleSuccess(){
        this.$refs.basicComponent.runQuery();
      },
      confirmToremove(){
        let selection = this.$refs.basicComponent.getSelection();
        if(selection && selection.length){
          let roleIds = [];
          for(let i in selection){
            roleIds.push(selection[i].id);
          }
          let url = this.baseAcsUrl + '/acs/role/delete-roles';
          this.dataLoading = true;
          this.http.delete(url,roleIds).then(resp =>{
            this.$message.success('Successful operation');
            this.$refs.deleteDialog.hideDialog();
            this.saveRoleSuccess();
            this.dataLoading = false;
          }).catch(error => {
            this.dataLoading = false;
            console.info(error);
            this.$message.warning('Operation failure');
          });

        }else{
          this.$message.warning("Please Select At Leaset one record");
        }


      },
      achieveState(){
        console.log('achieveState')
      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/view/acs/role/role_list.vue